import { cn } from "@/lib/utils"

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...props}
      data-slot="skeleton"
      className={cn("animate-pulse rounded-md bg-muted", className)}
    />
  )
}

export { Skeleton }
